import config from 'config';
import axiosInstance from '../API/createAxisInstance';

export default class API {
  static baseUrl = config.authBasePath;

  /**
   * @param {'GET'|'PUT'|'POST'|'DELETE'} method
   * @param {string} url
   * @param {object} [params]
   * @param {object} [data]
   * @param {object} [headers]
   * @param {string} [responseType]
   * @param {function} [mapper]
   * @returns {AxiosPromise}
   */
  static request({ method, url, params, data, headers, responseType, mapper = (data) => data }) {
    return axiosInstance({
      method,
      url: `${API.baseUrl}${url}`,
      params,
      data,
      headers,
      responseType,
    }).then((response) => {
      if (response.isOk) {
        return { ...response, data: mapper(response.data) };
      } else {
        return response;
      }
    });
  }
}
